"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/text");
let Spinner = class Spinner extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'element';
        this.label = '로딩 중';
    }
    render() {
        return (0, lit_1.html) `
      <span class="spinner" role="status" aria-label=${this.label}></span>
      ${this.renderLabel()}
    `;
    }
    renderLabel() {
        if (this.variant !== 'section')
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text class="label" aria-hidden="true">${this.label}</mm-text>
    `;
    }
};
Spinner.styles = (0, lit_1.css) `
    :host {
      --spinner-size: 1em;
      --spinner-track-color: transparent;
      --spinner-indicator-color: currentColor;

      display: inline-flex;
      align-items: center;
      gap: var(--space-2);
    }

    :host([variant='section']) {
      --spinner-size: var(--size-32);
      --spinner-track-color: var(--border-color);
      --spinner-indicator-color: var(--primary-color);

      flex-direction: column;
    }

    .spinner {
      width: var(--spinner-size);
      height: var(--spinner-size);
      flex-shrink: 0;
      border: 2px solid var(--spinner-track-color);
      border-top-color: var(--spinner-indicator-color);
      border-radius: 50%;
      box-sizing: border-box;
      animation: spin 0.8s linear infinite;
    }

    .label {
      font-size: var(--font-size-14);
      color: var(--foreground-subtle-color);
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Spinner.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Spinner.prototype, "label", void 0);
Spinner = __decorate([
    (0, decorators_js_1.customElement)('mm-spinner')
], Spinner);
exports.Spinner = Spinner;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3Bpbm5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNwaW5uZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQW9EO0FBQ3BELHFEQUEyRDtBQUUzRCx5Q0FBc0M7QUFLL0IsSUFBTSxPQUFPLEdBQWIsTUFBTSxPQUFRLFNBQVEsZ0JBQVU7SUFBaEM7O1FBMENzQyxZQUFPLEdBQW1CLFNBQVMsQ0FBQTtRQUNsRCxVQUFLLEdBQUcsTUFBTSxDQUFBO0lBZ0I1QyxDQUFDO0lBZEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7dURBQ3dDLElBQUksQ0FBQyxLQUFLO1FBQ3pELElBQUksQ0FBQyxXQUFXLEVBQUU7S0FDckIsQ0FBQTtJQUNILENBQUM7SUFFTyxXQUFXO1FBQ2pCLElBQUksSUFBSSxDQUFDLE9BQU8sS0FBSyxTQUFTO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFOUMsT0FBTyxJQUFBLFVBQUksRUFBQTtrREFDbUMsSUFBSSxDQUFDLEtBQUs7S0FDdkQsQ0FBQTtJQUNILENBQUM7O0FBekRNLGNBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQXdDbEIsQ0FBQTtBQUMwQztJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzt3Q0FBb0M7QUFDbEQ7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3NDQUFlO0FBM0MvQixPQUFPO0lBRG5CLElBQUEsNkJBQWEsRUFBQyxZQUFZLENBQUM7R0FDZixPQUFPLENBMkRuQjtBQTNEWSwwQkFBTyJ9